// src/components/FileUploadSection.js (MIGRADO A REACT ROUTER)

import React from 'react';
import { useNavigate } from 'react-router-dom'; // <--- CAMBIO CRÍTICO
import './FileUploadSection.css'; 
import { FiLock } from 'react-icons/fi'; 
import documentVisual from '../assets/images/documento-legal.png'; 

// Eliminamos la prop setActivePage
const FileUploadSection = () => {
    const navigate = useNavigate(); // <--- INICIALIZACIÓN

    return (
        <section id="file-promo-two-column" className="file-promo-container"> 
            <div className="promo-grid">
                
                {/* Columna 1: Imagen/Gráfico Profesional */}
                <div className="promo-visual-area">
                    <div className="document-mockup-container">
                         <img 
                            src={documentVisual} 
                            alt="Mockup de Documento Legal" 
                            className="document-mockup-img" 
                         />
                         <FiLock size={35} className="document-lock-icon" />
                    </div>
                    <p className="visual-caption">Garantía de confidencialidad, precisión y profesionalismo.</p>
                </div>

                {/* Columna 2: Título y Llamada a la Acción */}
                <div className="promo-content-area">
                    
                    <h3>Corrección y Edición de Documentos Legales y Financieros</h3>
                    
                    <p className="promo-intro-text">
                        Eleva la calidad de tus documentos a un estándar de élite. Nuestro equipo especializado corrige la **precisión legal, gramatical y estilística** de tus textos (contratos, informes, etc.).
                    </p>
                    
                    <ul className="feature-list">
                        <li>✅ Revisión por expertos legales y contables.</li>
                        <li>✅ Enfoque en la terminología técnica.</li>
                        <li>✅ Proceso seguro y confidencial.</li>
                    </ul>
                    
                    <button 
                        className="cta-button primary large-cta" 
                        // Usamos navigate('/file-upload') en lugar de setActivePage('fileUpload')
                        onClick={() => navigate('/file-upload')} 
                    >
                        Ver Precios y Subir Documento
                    </button>
                </div>
            </div>
        </section>
    );
};

export default FileUploadSection;